import React from "react"
import { BiPencil } from "react-icons/bi"
import { CgClose } from "react-icons/cg"

import type { EditablePreviewProps } from "@chakra-ui/react"
import {
  ButtonGroup,
  Editable,
  EditableInput,
  EditablePreview,
  Flex,
  IconButton,
  Stack,
  useEditableControls,
} from "@chakra-ui/react"

import { CheckmarkIcon } from "../../elements/icons/CheckmarkIcon"

type Props = {
  value?: string | undefined
  onSave: (value: string) => void
  previewProps?: EditablePreviewProps
}

export function InlineEditableField({ value, onSave, previewProps }: Props) {
  function EditableControls() {
    const {
      isEditing,
      getSubmitButtonProps,
      getCancelButtonProps,
      getEditButtonProps,
    } = useEditableControls()

    return isEditing ? (
      <ButtonGroup justifyContent="center" size="sm">
        <IconButton
          aria-label="Save"
          size="sm"
          colorScheme="primary"
          icon={<CheckmarkIcon />}
          {...getSubmitButtonProps()}
        />

        <IconButton
          aria-label="Cancel"
          size="sm"
          colorScheme="red"
          variant="ghost"
          icon={<CgClose />}
          {...getCancelButtonProps()}
        />
      </ButtonGroup>
    ) : (
      <Flex justifyContent="center">
        <IconButton
          aria-label="Edit"
          size="sm"
          colorScheme="tertiary"
          icon={<BiPencil />}
          {...getEditButtonProps()}
        />
      </Flex>
    )
  }

  return (
    <Editable
      textAlign="left"
      defaultValue={value}
      submitOnBlur={false}
      fontSize="16"
      isPreviewFocusable={false}
      onSubmit={onSave}
      w="full"
    >
      <Stack spacing={2} direction="row" align="center" justify="space-between">
        <EditablePreview w="full" minW="max-content" {...previewProps} />
        <EditableInput />
        <EditableControls />
      </Stack>
    </Editable>
  )
}
